//Announcement bar above menu slider

document.addEventListener('DOMContentLoaded', function() {
  const slider = document.querySelector('.cc-announcement-slider');
  if (!slider) return;

  const slides = slider.querySelectorAll('.cc-announcement-slider__slide');
  const nextArrow = slider.querySelector('.cc-announcement-slider__nav--next');
  const autoRotate = slider.getAttribute('data-auto-rotate') === 'true';
  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const sliderSpeed = parseInt(slider.getAttribute('data-slider-speed'), 10) * 1000 || 5000;

  if (!slides.length) return;

  let currentIndex = 0;
  let autoRotateInterval;

  function showSlide(index) {
    slides.forEach((slide, i) => {
      slide.style.opacity = '0';
      slide.style.display = 'none';
      slide.classList.remove('visible');
      slide.setAttribute('aria-hidden', 'true');
    });

    slides[index].style.display = 'block';
    slides[index].setAttribute('aria-hidden', 'false');
    setTimeout(() => {
      slides[index].style.opacity = '1';
      slides[index].classList.add('visible');
    }, 10); // Slight delay to allow opacity transition
  }

  function nextSlide() {
    currentIndex = (currentIndex + 1) % slides.length;
    showSlide(currentIndex);
  }

  function startAutoRotate() {
    stopAutoRotate(); // Clear any existing interval to avoid multiple intervals running.
    if (autoRotate && !reduceMotion && slides.length > 1) {
      autoRotateInterval = setInterval(nextSlide, sliderSpeed);
    }
  }

  function stopAutoRotate() {
    clearInterval(autoRotateInterval);
  }

  if (nextArrow) {
    nextArrow.addEventListener('click', () => {
      nextSlide();
      startAutoRotate(); // Restart the timer after manual interaction
    });
  }

  slider.addEventListener('mouseenter', stopAutoRotate);
  slider.addEventListener('mouseleave', startAutoRotate);
  slider.addEventListener('focusin', stopAutoRotate);
  slider.addEventListener('focusout', (event) => {
    if (!slider.contains(event.relatedTarget)) startAutoRotate();
  });

  // Start the slider initially
  showSlide(currentIndex);
  startAutoRotate();
});

// Back button with scroll position memory
(function() {
  var SCROLL_STORAGE_KEY = 'betseys_scroll_positions';

  function getScrollPositions() {
    try {
      var data = sessionStorage.getItem(SCROLL_STORAGE_KEY);
      return data ? JSON.parse(data) : {};
    } catch (e) {
      return {};
    }
  }

  function saveScrollPosition() {
    try {
      var positions = getScrollPositions();
      positions[window.location.href] = window.scrollY || window.pageYOffset;
      sessionStorage.setItem(SCROLL_STORAGE_KEY, JSON.stringify(positions));
    } catch (e) {}
  }

  function restoreScrollPosition() {
    try {
      var positions = getScrollPositions();
      var savedPosition = positions[window.location.href];
      if (typeof savedPosition === 'number') {
        setTimeout(function() {
          window.scrollTo(0, savedPosition);
        }, 100);
      }
    } catch (e) {}
  }

  function isSameOrigin(url) {
    try {
      var link = document.createElement('a');
      link.href = url;
      return link.hostname === window.location.hostname;
    } catch (e) {
      return false;
    }
  }

  // Save scroll position before leaving the page
  window.addEventListener('beforeunload', saveScrollPosition);

  // Save scroll position on same-origin link clicks
  document.addEventListener('click', function(e) {
    var link = e.target.closest('a');
    if (link && link.href && isSameOrigin(link.href)) {
      saveScrollPosition();
    }
  });

  // Restore scroll position on page load
  document.addEventListener('DOMContentLoaded', function() {
    restoreScrollPosition();

    // Back button click handler
    var prevArrow = document.querySelector('.cc-announcement-slider__nav--prev');
    if (prevArrow) {
      prevArrow.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var referrer = document.referrer;
        if (referrer && isSameOrigin(referrer)) {
          window.history.back();
        } else {
          window.location.href = '/collections/all';
        }
      });
    }
  });
})();

class ProductGroupingSwatches extends HTMLElement {
  constructor() {
    super();
    this.handleVariantChange = this.handleVariantChange.bind(this);
  }

  connectedCallback() {
    if (this.initialized) return;

    this.productArea = this.closest('.product-area');
    this.currentProductId = String(this.dataset.currentProductId);
    this.colorOptionName = this.normalizeOptionName(this.dataset.colorOptionName);
    this.products = new Map();

    this.querySelectorAll('[data-grouped-product-json]').forEach((element) => {
      try {
        const productData = JSON.parse(element.textContent);
        this.products.set(String(productData.id), productData);
      } catch (error) {
        return;
      }
    });

    this.currentProduct = this.products.get(this.currentProductId);
    if (!this.productArea || !this.currentProduct) return;

    this.initialized = true;
    this.productArea.addEventListener('change', this.handleVariantChange);
    this.updateFromCurrentSelection();
  }

  disconnectedCallback() {
    if (this.productArea) {
      this.productArea.removeEventListener('change', this.handleVariantChange);
    }
    this.initialized = false;
  }

  normalizeOptionName(optionName) {
    return String(optionName || '').trim().toLowerCase();
  }

  getOptionNames(productData) {
    return (productData.options || []).map((option) => {
      return this.normalizeOptionName(typeof option === 'string' ? option : option.name);
    });
  }

  getCurrentVariant(variantId) {
    const variants = this.currentProduct.variants || [];
    return variants.find((variant) => String(variant.id) === String(variantId));
  }

  updateFromCurrentSelection() {
    const variantInput = this.productArea.querySelector('select.original-selector[name="id"]') ||
      this.productArea.querySelector('[name="id"]');
    const variantFromUrl = new URL(window.location.href).searchParams.get('variant');
    const currentVariant = this.getCurrentVariant(variantInput ? variantInput.value : variantFromUrl) ||
      (this.currentProduct.variants || []).find((variant) => variant.available) ||
      (this.currentProduct.variants || [])[0];

    if (currentVariant) {
      this.updateSwatches(currentVariant);
    }
  }

  getSelectedOptions(currentVariant) {
    const selectedOptions = new Map();
    const optionNames = this.getOptionNames(this.currentProduct);

    optionNames.forEach((optionName, index) => {
      if (optionName && optionName !== this.colorOptionName && currentVariant.options[index] != null) {
        selectedOptions.set(optionName, currentVariant.options[index]);
      }
    });

    return selectedOptions;
  }

  getSelectedOptionsFromControls() {
    const selectedOptions = new Map();

    this.productArea.querySelectorAll('.option-selectors .selector-wrapper[data-option-name]').forEach((wrapper) => {
      const optionName = this.normalizeOptionName(wrapper.dataset.optionName);
      const select = wrapper.querySelector('select');

      if (optionName && optionName !== this.colorOptionName && select) {
        selectedOptions.set(optionName, select.value);
      }
    });

    return selectedOptions;
  }

  findMatchingVariant(productData, selectedOptions) {
    const variants = productData.variants || [];
    const optionNames = this.getOptionNames(productData);
    const sharedOptions = [];

    selectedOptions.forEach((value, optionName) => {
      const optionIndex = optionNames.indexOf(optionName);
      if (optionIndex !== -1) {
        sharedOptions.push({ optionIndex, value });
      }
    });

    if (sharedOptions.length === 0) {
      return variants.find((variant) => variant.available) || variants[0] || null;
    }

    const matchingVariants = variants.filter((variant) => {
      return sharedOptions.every(({ optionIndex, value }) => variant.options[optionIndex] === value);
    });

    if (matchingVariants.length === 0) return null;
    return matchingVariants.find((variant) => variant.available) || matchingVariants[0];
  }

  buildVariantUrl(productUrl, variant) {
    const url = new URL(productUrl, window.location.origin);
    if (variant) {
      url.searchParams.set('variant', variant.id);
    } else {
      url.searchParams.delete('variant');
    }
    return `${url.pathname}${url.search}${url.hash}`;
  }

  updateSwatches(currentVariant, selectedOptionsOverride) {
    const selectedOptions = selectedOptionsOverride || this.getSelectedOptions(currentVariant);

    this.querySelectorAll('[data-grouped-product-id]').forEach((swatch) => {
      const productId = String(swatch.dataset.groupedProductId);
      const productData = this.products.get(productId);
      if (!productData) return;

      const matchingVariant = productId === this.currentProductId && currentVariant ?
        currentVariant :
        this.findMatchingVariant(productData, selectedOptions);
      const unavailable = !matchingVariant || !matchingVariant.available;

      swatch.classList.toggle('unavailable', unavailable);
      const unavailableLabel = swatch.querySelector('[data-grouped-product-unavailable]');
      if (unavailableLabel) {
        unavailableLabel.hidden = !unavailable;
      }

      if (swatch.matches('a')) {
        if (matchingVariant) {
          swatch.href = this.buildVariantUrl(swatch.dataset.productUrl, matchingVariant);
          swatch.removeAttribute('aria-disabled');
        } else {
          swatch.removeAttribute('href');
          swatch.setAttribute('aria-disabled', 'true');
        }
      }
    });
  }

  handleVariantChange(event) {
    if (!(event.target instanceof Element) || !event.target.matches('[name="id"]')) return;

    if (event.detail === false) {
      this.updateSwatches(null, this.getSelectedOptionsFromControls());
      return;
    }

    const eventVariant = event.detail && Array.isArray(event.detail.options) ? event.detail : null;
    const currentVariant = eventVariant || this.getCurrentVariant(event.target.value);
    if (currentVariant) {
      this.updateSwatches(currentVariant);
    }
  }
}

if (!customElements.get('product-grouping-swatches')) {
  customElements.define('product-grouping-swatches', ProductGroupingSwatches);
}

//Make the legacy product detail tabs fully keyboard and screen-reader operable
//without changing their existing classes or presentation.
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.d-tabs').forEach(function(tabSet, setIndex) {
    var tabList = tabSet.querySelector('.d-tabs-nav ul');
    var tabs = Array.from(tabSet.querySelectorAll('.d-tabs-nav li'));
    var panels = Array.from(tabSet.querySelectorAll('.d-panel'));
    if (!tabList || !tabs.length) return;

    tabList.setAttribute('role', 'tablist');

    function activateTab(tab, moveFocus) {
      var tabClass = Array.from(tab.classList).find(function(className) {
        return className.indexOf('d-') === 0 && className !== 'd-tabs';
      });

      tabs.forEach(function(item) {
        var selected = item === tab;
        item.classList.toggle('active', selected);
        item.setAttribute('aria-selected', String(selected));
        item.setAttribute('tabindex', selected ? '0' : '-1');
      });

      panels.forEach(function(panel) {
        var selected = tabClass && panel.classList.contains(tabClass + '-panel');
        panel.classList.toggle('active', selected);
        panel.hidden = !selected;
      });

      if (moveFocus) tab.focus();
    }

    tabs.forEach(function(tab, tabIndex) {
      var panel = panels[tabIndex];
      var tabId = 'product-tab-' + setIndex + '-' + tabIndex;
      var panelId = 'product-tab-panel-' + setIndex + '-' + tabIndex;
      tab.id = tabId;
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', panelId);

      if (panel) {
        panel.id = panelId;
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tabId);
        panel.setAttribute('tabindex', '0');
      }

      tab.addEventListener('click', function() {
        activateTab(tab, false);
      });
      tab.addEventListener('keydown', function(event) {
        var nextIndex;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          nextIndex = (tabIndex + 1) % tabs.length;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          nextIndex = (tabIndex - 1 + tabs.length) % tabs.length;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = tabs.length - 1;
        } else if (event.key === 'Enter' || event.key === ' ') {
          nextIndex = tabIndex;
        } else {
          return;
        }
        event.preventDefault();
        activateTab(tabs[nextIndex], true);
      });
    });

    activateTab(tabs.find(function(tab) { return tab.classList.contains('active'); }) || tabs[0], false);
  });

  document.querySelectorAll('img[src*="model-image.jpg"]:not([alt])').forEach(function(image) {
    var modelHeading = image.closest('.d-model-panel') && image.closest('.d-model-panel').querySelector('h2, h3, h4, h5, h6');
    image.alt = modelHeading ? modelHeading.textContent.trim() : '';
  });

  document.querySelectorAll('.d-panel h4').forEach(function(heading) {
    heading.setAttribute('aria-level', '2');
  });
});

// Wishlist Club replaces its product control whenever its state or variant changes.
// Reapply semantics to the new controls without changing the app's click handlers.
(function() {
  'use strict';

  var observedProductArea = null;
  var wishlistObserver = null;
  var enhancementFrame = null;
  var menuSequence = 0;
  var lastTrigger = new WeakMap();
  var translatedStrings = null;

  function wishlistStrings() {
    if (translatedStrings !== null) return translatedStrings;

    var source = document.getElementById('bb-wishlist-a11y-strings');
    try {
      translatedStrings = source ? JSON.parse(source.textContent) : {};
    } catch (error) {
      translatedStrings = {};
    }
    return translatedStrings;
  }

  function wishlistLabel(widget) {
    var strings = wishlistStrings();
    var headerLink = document.querySelector('a[href="/apps/wishlist"][aria-label]');
    var visibleLabel = widget.querySelector('.th_wl_text');
    return strings.wishlist ||
      (headerLink && headerLink.getAttribute('aria-label')) ||
      (visibleLabel && visibleLabel.textContent.trim()) || '';
  }

  function menuIsOpen(menu) {
    return Boolean(menu && window.getComputedStyle(menu).display !== 'none');
  }

  function syncWishlistState(widget) {
    var menu = widget.querySelector('.th_wl_dropdown_content');
    if (!menu) return;

    var open = menuIsOpen(menu);
    menu.setAttribute('aria-hidden', String(!open));

    widget.querySelectorAll('[data-bb-wishlist-controls="' + menu.id + '"]').forEach(function(control) {
      control.setAttribute('aria-expanded', String(open));
    });

    menu.querySelectorAll('.th_wl_dropdown_option, .th_wl_wishlist_list_from_dropdown, .th_wl_dropdown_option_delete_btn').forEach(function(option) {
      if (option.classList.contains('th_wl_dropdown_option') && option.closest('.th_wl_wishlist_list_from_dropdown')) return;
      option.setAttribute('tabindex', open ? '0' : '-1');
    });
  }

  function closeWishlistMenu(widget, restoreFocus) {
    var menu = widget.querySelector('.th_wl_dropdown_content');
    if (!menu || !menuIsOpen(menu)) return;

    menu.style.display = 'none';
    syncWishlistState(widget);

    if (restoreFocus) {
      var trigger = lastTrigger.get(widget) || widget.querySelector('.th_wl_dropbtn, .th_wl_button, .th_wl_button_after');
      if (trigger) trigger.focus();
    }
  }

  function makeKeyboardButton(element) {
    if (!element || element.dataset.bbWishlistKeyboard === 'true') return;

    element.dataset.bbWishlistKeyboard = 'true';
    element.setAttribute('role', 'button');
    element.setAttribute('tabindex', '0');
    element.addEventListener('keydown', function(event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      element.click();
    });
  }

  function makeKeyboardCheckbox(element) {
    if (!element) return;

    element.setAttribute('role', 'checkbox');
    element.setAttribute('tabindex', '0');
    element.setAttribute('aria-checked', String(element.dataset.th_wl_wishlist_status === 'true'));
    if (element.dataset.bbWishlistKeyboard === 'true') return;

    element.dataset.bbWishlistKeyboard = 'true';
    element.addEventListener('keydown', function(event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      element.click();
    });
  }

  function enhanceWishlistWidget(widget) {
    var row = widget.querySelector(':scope > .d-flex');
    var mainButton = row && row.querySelector(':scope > .th_wl_button, :scope > .th_wl_button_after');
    var dropdown = row && row.querySelector(':scope > .th_wl_dropdown');
    var dropdownButton = dropdown && dropdown.querySelector('.th_wl_dropbtn');
    var menu = dropdown && dropdown.querySelector('.th_wl_dropdown_content');

    if (!row || !mainButton) return;

    makeKeyboardButton(mainButton);
    mainButton.removeAttribute('onfocusout');

    widget.querySelectorAll('svg').forEach(function(icon) {
      icon.setAttribute('aria-hidden', 'true');
      icon.setAttribute('focusable', 'false');
    });

    if (dropdown && dropdownButton && menu) {
      dropdown.removeAttribute('onfocusout');
      dropdownButton.classList.add('no-hover');

      if (!menu.id) {
        menuSequence += 1;
        menu.id = 'bb-wishlist-options-' + menuSequence;
      }

      var label = wishlistLabel(widget);
      if (label) dropdownButton.setAttribute('aria-label', label);
      dropdownButton.setAttribute('aria-controls', menu.id);
      dropdownButton.setAttribute('data-bb-wishlist-controls', menu.id);

      if ((mainButton.getAttribute('onclick') || '').indexOf('dropdown') !== -1) {
        mainButton.setAttribute('aria-controls', menu.id);
        mainButton.setAttribute('data-bb-wishlist-controls', menu.id);
      } else {
        mainButton.removeAttribute('aria-controls');
        mainButton.removeAttribute('aria-expanded');
        mainButton.removeAttribute('data-bb-wishlist-controls');
      }

      menu.querySelectorAll('.th_wl_wishlist_list_from_dropdown').forEach(function(choice) {
        makeKeyboardCheckbox(choice);
        choice.setAttribute('aria-checked', String(choice.dataset.th_wl_wishlist_status === 'true'));

        var nativeCheckbox = choice.querySelector('input[type="checkbox"]');
        if (nativeCheckbox) {
          nativeCheckbox.setAttribute('tabindex', '-1');
          nativeCheckbox.setAttribute('aria-hidden', 'true');
        }

        var nestedLabel = choice.querySelector('.th_wl_dropdown_option');
        if (nestedLabel) {
          nestedLabel.removeAttribute('role');
          nestedLabel.removeAttribute('tabindex');
          nestedLabel.removeAttribute('data-bb-wishlist-keyboard');
        }
      });

      menu.querySelectorAll('.th_wl_dropdown_option').forEach(function(option) {
        if (!option.closest('.th_wl_wishlist_list_from_dropdown')) makeKeyboardButton(option);
      });

      menu.querySelectorAll('.th_wl_dropdown_option_delete_btn').forEach(function(deleteButton) {
        makeKeyboardButton(deleteButton);

        var listItem = deleteButton.closest('li');
        var listNameElement = listItem && listItem.querySelector('.th_wl_dropdown_option');
        var listName = listNameElement && listNameElement.textContent.trim();
        var removeLabel = wishlistStrings().remove;
        if (removeLabel && listName) deleteButton.setAttribute('aria-label', removeLabel + ': ' + listName);
      });

      if (row.dataset.bbWishlistEvents !== 'true') {
        row.dataset.bbWishlistEvents = 'true';

        row.addEventListener('click', function(event) {
          if (event.target.closest('.th_wl_button, .th_wl_button_after, .th_wl_dropbtn')) {
            lastTrigger.set(widget, event.target.closest('.th_wl_button, .th_wl_button_after, .th_wl_dropbtn'));
          }
          syncWishlistState(widget);
        });

        row.addEventListener('keydown', function(event) {
          if (event.key !== 'Escape' || !menuIsOpen(menu)) return;
          event.preventDefault();
          closeWishlistMenu(widget, true);
        });

        row.addEventListener('focusout', function() {
          window.setTimeout(function() {
            if (!row.contains(document.activeElement)) closeWishlistMenu(widget, false);
          }, 0);
        });
      }
    }

    syncWishlistState(widget);
  }

  function enhanceWishlists() {
    enhancementFrame = null;
    document.querySelectorAll('.th_prd_wl_btn').forEach(enhanceWishlistWidget);
  }

  function scheduleWishlistEnhancement() {
    if (enhancementFrame !== null) return;
    enhancementFrame = window.requestAnimationFrame(enhanceWishlists);
  }

  function observeWishlistArea() {
    var productArea = document.querySelector('.product-area');
    if (!productArea || productArea === observedProductArea) {
      scheduleWishlistEnhancement();
      return;
    }

    if (wishlistObserver) wishlistObserver.disconnect();
    observedProductArea = productArea;
    wishlistObserver = new MutationObserver(scheduleWishlistEnhancement);
    wishlistObserver.observe(productArea, {
      childList: true,
      subtree: true
    });
    scheduleWishlistEnhancement();
  }

  document.addEventListener('click', function(event) {
    document.querySelectorAll('.th_prd_wl_btn').forEach(function(widget) {
      if (!widget.contains(event.target)) closeWishlistMenu(widget, false);
    });
  });
  document.addEventListener('shopify:section:load', observeWishlistArea);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeWishlistArea, { once: true });
  } else {
    observeWishlistArea();
  }
  window.addEventListener('load', observeWishlistArea, { once: true });
})();

/* wp-281650557 - let shoppers select a fully-sold-out colour/size so the Notify Me button appears.
   Showcase's theme.convertOptionsToBoxes hard-disables any option value that has zero available
   variants (.addClass("unavailable").attr({"aria-disabled":"true"})), and the clickybox click
   handler returns early on that attribute - so Navy-sold-out-in-every-size became unclickable and
   the shopper could never reach the back-in-stock form. Drop the attribute only; the .unavailable
   class carries the sold-out styling and is left alone, and Add to Cart stays disabled by the
   theme's own availability logic.
   Scoped to .clickyboxes and explicitly NOT to [data-grouped-product-id] - the grouped-product
   swatches above use aria-disabled to mark an anchor whose href has been removed, and unlocking
   one of those would produce a dead link. */
(function () {
  function unlock(root) {
    (root || document)
      .querySelectorAll('.clickyboxes a[aria-disabled="true"]:not([data-grouped-product-id])')
      .forEach(function (a) {
        a.removeAttribute('aria-disabled');
        a.setAttribute('tabindex', a.classList.contains('active') ? '0' : '-1');
      });
  }

  function start() {
    unlock();
    // convertOptionsToBoxes re-runs on every section render (quick-buy, quick-view, section
    // reload), so a one-shot pass would leave those surfaces disabled.
    new MutationObserver(function () { unlock(); }).observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['aria-disabled']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
